"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldNumber = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const Icon_1 = require("../../../Icon");
const Wrapper_1 = require("../Wrapper");
require("./index.scss");
const className = 'form-field-number';
const FormFieldNumber = (props) => {
    const { value = 0, setValue, nativeValue, onChange, step = 1, label, info, error, tooltipIconHidden, required, disabled, hidden, modificators, additionClassNames, } = props;
    if (hidden)
        return null;
    const formFieldWrapperProps = {
        label,
        error,
        info,
        tooltipIconHidden,
        additionClassNames: (0, classFunctions_1.getClassNames)(className, modificators, additionClassNames),
        modificators,
        required,
        slot: (react_1.default.createElement("div", { className: `${className}__row` },
            react_1.default.createElement("div", { className: `${className}__spin` },
                react_1.default.createElement("button", { type: 'button', role: 'button', onClick: () => {
                        setValue === null || setValue === void 0 ? void 0 : setValue(value - step);
                    }, disabled: disabled },
                    react_1.default.createElement(Icon_1.Icon, { name: 'minus' }))),
            react_1.default.createElement("div", { className: `${className}__input` },
                react_1.default.createElement("input", { type: 'number', min: '0', value: nativeValue !== null && nativeValue !== void 0 ? nativeValue : value, onChange: onChange, disabled: disabled })),
            react_1.default.createElement("div", { className: `${className}__spin` },
                react_1.default.createElement("button", { type: 'button', role: 'button', onClick: () => {
                        setValue === null || setValue === void 0 ? void 0 : setValue(value + step);
                    }, disabled: disabled },
                    react_1.default.createElement(Icon_1.Icon, { name: 'plus' }))))),
    };
    return (react_1.default.createElement(Wrapper_1.FormFieldWrapper, { ...formFieldWrapperProps }));
};
exports.FormFieldNumber = FormFieldNumber;
//# sourceMappingURL=index.js.map